import React, { useState, useEffect } from 'react';
import Header from '../components/header';

const API_GET_ROUTES = 'https://app.mirzawaleed.com/getroutes.php';
const API_ADD_ROUTE = 'https://app.mirzawaleed.com/addroute.php';
const API_DELETE_ROUTE = 'https://app.mirzawaleed.com/deleteroute.php';

const RoutesPage = () => {
  const [routes, setRoutes] = useState([]);
  const [newRouteName, setNewRouteName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRoutes();
  }, []);

  const fetchRoutes = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_GET_ROUTES);
      const data = await response.json();
      setRoutes(data || []);
    } catch (error) {
      console.error('Error fetching routes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddRoute = async () => {
    if (!newRouteName.trim()) {
      alert('Please enter a route name.');
      return;
    }
    try {
      const response = await fetch(API_ADD_ROUTE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newRouteName, addpreviousbalance: false }),
      });
      const result = await response.json();
      if (result.success) {
        setNewRouteName('');
        fetchRoutes();
      } else {
        alert('Error adding route: ' + result.message);
      }
    } catch (error) {
      console.error('Error adding route:', error);
    }
  };

  const handleDeleteRoute = async (id) => {
    if (!window.confirm('Are you sure you want to delete this route?')) return;

    try {
      const response = await fetch(API_DELETE_ROUTE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      });
      const result = await response.json();
      if (result.success) {
        fetchRoutes();
      } else {
        alert('Error deleting route: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting route:', error);
    }
  };

  return (
    <>
      <Header />
      <div style={styles.container}>
        <h2 style={styles.heading}>🚚 Manage Routes</h2>

        {/* Add Route Section */}
        <div style={styles.inputSection}>
          <input
            type="text"
            value={newRouteName}
            onChange={(e) => setNewRouteName(e.target.value)}
            placeholder="Enter new route"
            style={styles.input}
          />
          <button onClick={handleAddRoute} style={styles.addButton}>
            ➕ Add Route
          </button>
        </div>

        {/* Route List */}
        {loading ? (
          <p>Loading routes...</p>
        ) : routes.length === 0 ? (
          <p style={styles.noData}>No routes found.</p>
        ) : (
          <ul style={styles.list}>
            {routes.map((route) => (
              <li key={route.id} style={styles.listItem}>
                <span>{route.name}</span>
                <button
                  onClick={() => handleDeleteRoute(route.id)}
                  style={styles.deleteButton}
                >
                  ❌ Delete
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '100px auto',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
  },
  heading: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '20px',
  },
  inputSection: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    flex: 1,
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
  },
  addButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 15px',
    cursor: 'pointer',
    fontSize: '14px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  listItem: {
    backgroundColor: '#f9f9f9',
    marginBottom: '8px',
    padding: '10px',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '6px 10px',
    cursor: 'pointer',
    fontSize: '13px',
  },
  noData: {
    textAlign: 'center',
    color: '#777',
    fontStyle: 'italic',
  },
};

export default RoutesPage;
